"use client";

import React from "react";
import { Handshake, Landmark, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseAreas = [{
  title: "Luxury Expeditions",
  description: "Indulge in the world's most exclusive retreats. From private island villas to five-star safari lodges, we curate high-end journeys with seamless logistics and unparalleled personal service.",
  icon: Landmark
}, {
  title: "Adventure Quests",
  description: "Push your boundaries with rugged expeditions. Trek through remote mountain ranges, dive into hidden cenotes, or navigate wild rivers with expert guides and top-tier equipment.",
  icon: Handshake
}, {
  title: "Family Discoveries",
  description: "Create lasting memories with multi-generational travel. We design educational and fun itineraries that cater to all ages, ensuring comfort and engagement for every family member.",
  icon: Users
}];
export default function CuratedExpeditionTiers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222090" id="curated-expedition-tiers" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-lg blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-sm font-bold tracking-widest text-ring uppercase mb-4 font-mono">
            Choose Your Journey
          </h2>
          <h3 className="text-4xl md:text-6xl font-bold font-default text-foreground leading-tight uppercase tracking-tight">
            Curated Expedition Tiers
          </h3>
          <p className="mt-6 text-lg text-muted-foreground font-sans leading-relaxed">
            Select the travel style that speaks to your soul. Whether you seek the pinnacle of comfort or the thrill of the unknown, Wanderlust Expeditions delivers excellence.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {expertiseAreas.map((area, i) => <Card key={i} data-index={i} className={`group p-10 bg-card/50 backdrop-blur-md border border-white/10 hover:border-ring shadow-md hover:shadow-2xl transition-all duration-500 ease-out flex flex-col h-full transform rounded-md ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <CardHeader className="p-0 mb-8">
                <div className="w-16 h-16 rounded-md bg-primary/20 flex items-center justify-center mb-8 border border-primary/30 transition-colors duration-300 group-hover:bg-ring/10 group-hover:border-ring/40">
                  <area.icon className="w-8 h-8 text-ring transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-2xl font-bold font-default text-foreground group-hover:text-ring transition-colors duration-300 uppercase">
                  {area.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 flex-grow">
                <p className="text-muted-foreground font-sans leading-relaxed text-base">
                  {area.description}
                </p>
              </CardContent>
              
              {}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-ring transition-all duration-500 ease-out group-hover:w-full"></div>
            </Card>)}
        </div>
      </div>
    </section>;
}